import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/mall/cardCoupon/selectCardCoupon`,
    method: "POST",
    data,
  });
}

/**
 * 新增优惠券
 * @param {*} data
 * @returns
 */
export function addApi(data) {
  return request({
    url: `/admin/mall/cardCoupon/add`,
    method: "POST",
    data,
  });
}


/**
 * 修改
 * @param {*} data
 * @returns
 */
export function updateApi(data) {
  return request({
    url: `/admin/mall/cardCoupon/update`,
    method: "POST",
    data,
  });
}

/*删除 */
export function deleteApi(data) {
  return request({
    url: `/admin/mall/cardCoupon/delete`,
    method: "POST",
    data,
  });
}


/**
 * 批量新增卡券
 * @param {*} data
 * @returns
 */
export function addListApi(data) {
  return request({
    url: `/admin/mall/cardCoupon/addCardCoupon`,
    method: "POST",
    data,
  });
}
